import axios from 'axios';
import Auth from './auth';
import { API_ROOT } from './apiConfig';

const auth = new Auth();

export default class DistributionDataAccess {

    getByAccount(account) {
        return new Promise((resolve, reject) => {
            axios.get(`${API_ROOT}/api/v1/Reports/GetDistributionAddresses?account=${encodeURIComponent(account)}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${auth.getToken()}`
                }
            }).then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    }

    getAddresses(account) {
        // returns list used for autocomplete (Name, Address, Account, Id)
        return new Promise((resolve, reject) => {
            axios.get(`${API_ROOT}/api/v1/distributions/addresses?account=${encodeURIComponent(account)}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${auth.getToken()}`
                }
            }).then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    }

    saveDistribution(distribution) {
        // Creates or updates distribution record
        return new Promise((resolve, reject) => {
            axios.post(`${API_ROOT}/api/v1/Reports/UpdateDistributionAddresses`, distribution, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${auth.getToken()}`
                }
            }).then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    }

    deleteDistribution(account, id) {
        return new Promise((resolve, reject) => {
            axios.delete(`${API_ROOT}/api/v1/Reports/DeleteDistributionAddress/${account}/${id}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${auth.getToken()}`
                }
            }).then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/distributionDataAccess.js